/**
 * Satisfaction Surveys Module
 */
(function(){
    'use strict';
    angular.module('elogbooks.helpdesk.satisfactionsurveys', []);
})();
